// @flow
import React, { Component } from 'react';
import PartneringPartnerCards from 'containers/list/PartneringPartnerCards';
import PartneringTemplate from 'components/partnering/PartneringTemplate/PartneringTemplate';
import { Helmet } from 'react-helmet';
import ScrollToTop from 'components/common/ScrollToTop';
import type { ContextRouter } from 'react-router-dom';
import queryString from 'query-string';

type Props = {} & ContextRouter;

class Partnering extends Component<Props> {
  render() {
    const { location, match, history } = this.props;
    const { sort } = queryString.parse(location.search);
    const { category } = match.params;
    return (
      <PartneringTemplate>
        <Helmet>
          <title>파트너 | 캐시바이</title>
          <meta
            name="description"
            content="캐시바이에 방금 등록된 따끈따끈한 파트너들을 살펴보세요."
          />
        </Helmet>
        <PartneringPartnerCards category={category} sort={sort} />
      </PartneringTemplate>
    );
  }
}

export default Partnering;



// WEBPACK FOOTER //
// ./src/pages/Partnering.js